import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB;

const DispatchByPlaceService = {
    apply: async (payload) => axios.post(API_URL + "/dispatch_by_place/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default DispatchByPlaceService;